import Colors from "./colors"
import { breakpoints } from "./media"
import Shadows from "./shadows"
import Media from "./media"

const MainTheme = {
  breakpoints,
  fontSizes: [14, 16, 18, 24, 32, 48],
  lineHeight: ["20px", "24px", "24px", "32px", "44px", "64px"],
  space: [6, 12, 16, 24, 42, 48, 56, 64, 72, 80, 88, 96, 120, 144, 164],
  colors: Colors
}

export { Colors, MainTheme, Shadows, Media }



// WEBPACK FOOTER //
// ./src/lib/theme/index.js